import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class MenuSkeleton extends Vue {
  @Prop({ default: 'solicitud' })
  public icono!: string;
}
